import { getSupabaseClient } from '../../../../core/supabase/client.js';
import {
  PRIZE1_FIELD_CODE,
  PRIZE2_FIELD_CODE,
  PRIZE3_FIELD_CODE,
} from '../../domain/prizeRates.js';
import type { PublicReceiptDto } from '../dtos/PublicReceiptDto.js';

export class PublicReceiptRemoteDataSource {
  private get supabase() { return getSupabaseClient() as any; }

  /**
   * Calls the SECURITY DEFINER RPC (granted to anon). The prize field codes are
   * forwarded so the server classifies tiers exactly like the dashboard; rates
   * stay client-side. Returns null when the location code does not exist.
   */
  async getByCode(code: string): Promise<PublicReceiptDto | null> {
    const { data, error } = await this.supabase.rpc('public_payout_receipt', {
      p_code: code,
      p_prize1_code: PRIZE1_FIELD_CODE ?? null,
      p_prize2_code: PRIZE2_FIELD_CODE ?? null,
      p_prize3_code: PRIZE3_FIELD_CODE ?? null,
    });
    if (error) throw new Error(error.message);
    return (data as PublicReceiptDto | null) ?? null;
  }
}
